"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceModificationToJSON = exports.PriceModificationFromJSONTyped = exports.PriceModificationFromJSON = void 0;
var _1 = require("./");
function PriceModificationFromJSON(json) {
    return PriceModificationFromJSONTyped(json, false);
}
exports.PriceModificationFromJSON = PriceModificationFromJSON;
function PriceModificationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'value': (0, _1.AmountFromJSON)(json['value']),
        'isNegative': json['isNegative'],
    };
}
exports.PriceModificationFromJSONTyped = PriceModificationFromJSONTyped;
function PriceModificationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'value': (0, _1.AmountToJSON)(value.value),
        'isNegative': value.isNegative,
    };
}
exports.PriceModificationToJSON = PriceModificationToJSON;
//# sourceMappingURL=PriceModification.js.map